import type { PartnerResponsible } from 'shared/api/afterSalesApi'

import type {
  ContactResponsible,
  InternalSupportContacts
} from './InnoscriptaContacts.types'

/** i18n key prefix shared by every part of the contacts popup. */
export const CONTACTS_KEY_PREFIX = 'navbar.innoscripta_contacts'

/** `responsible_type_id`s the contacts popup knows how to render. */
export const RESPONSIBLE_TYPE_ID = {
  SALES_REP: 2,
  CASE_MANAGER: 4,
  AFTER_SALES: 9,
  CUSTOMER_SUCCESS: 13,
  SOFTWARE_SUPPORT: 98
} as const

/**
 * BSFZ and cashback applications always need a contact, so these two stand in
 * whenever the partner has nobody assigned for the role. After sales and sales
 * representatives have no stand-in — their rows are simply left out.
 */
export const DEFAULT_CASE_MANAGER: PartnerResponsible = {
  id: 143521,
  responsible_type_id: RESPONSIBLE_TYPE_ID.CASE_MANAGER,
  created_at: '2026-01-06T13:26:55.000000Z',
  user: {
    id: 143521,
    name: 'Vanessa Bischur',
    avatar:
      'https://innos.s3.eu-central-1.amazonaws.com/employees_avatars/4393.jpg',
    email: 'bischur@innoscripta.com',
    working_phone: '+4989541987727'
  },
  responsible_type: {
    id: RESPONSIBLE_TYPE_ID.CASE_MANAGER,
    name: 'Case Manager',
    display_name: 'Case Manager'
  }
}

export const DEFAULT_CUSTOMER_SUCCESS: PartnerResponsible = {
  id: 130935,
  responsible_type_id: RESPONSIBLE_TYPE_ID.CUSTOMER_SUCCESS,
  created_at: '2026-01-06T13:26:55.000000Z',
  user: {
    id: 130935,
    name: 'Alexander Grimm',
    avatar:
      'https://innos.s3.eu-central-1.amazonaws.com/employees_avatars/1009.jpg',
    email: 'alexander.grimm@innoscripta.com',
    working_phone: '+4989541987688'
  },
  responsible_type: {
    id: RESPONSIBLE_TYPE_ID.CUSTOMER_SUCCESS,
    name: 'FA-Antrag',
    display_name: 'FA-Antrag'
  }
}

/** Shown to every SFF partner, independent of assigned responsibilities. */
export const SOFTWARE_SUPPORT_CONTACT: ContactResponsible = {
  id: 5,
  responsible_type_id: RESPONSIBLE_TYPE_ID.SOFTWARE_SUPPORT,
  user: {
    id: 5,
    name: 'Johannes Rekowski',
    avatar: 'https://innos.s3.eu-central-1.amazonaws.com/auth/avatars/5',
    email: 'rekowski@innoscripta.com',
    working_phone: '+4989262004187'
  },
  responsible_type: {
    id: RESPONSIBLE_TYPE_ID.SOFTWARE_SUPPORT,
    name: 'SOFTWARE_SUPPORT',
    display_name: 'Software Support'
  }
}

const makeInternalContact = (
  id: number,
  email: string
): ContactResponsible => ({
  id,
  responsible_type_id: null,
  user: {
    id,
    name: '',
    avatar: null,
    email,
    working_phone: null
  }
})

export const INTERNAL_SUPPORT_CONTACTS: InternalSupportContacts = {
  alihanIpekten: makeInternalContact(158294, 'ipekten@innoscripta.com'),
  mariaStephan: makeInternalContact(5617, 'm.stephan@innoscripta.com'),
  muhammedHasanAnees: makeInternalContact(145344, 'anees@clustermailbox.de'),
  mohamedMosadRagab: makeInternalContact(1040438, 'ragab@innoscripta.com'),
  amirhosseinMoghadam: makeInternalContact(
    143515,
    'moghadam@clustermailbox.de'
  ),
  vrushaliRai: makeInternalContact(155444, 'rai@clustermailbox.de'),
  sayedAbdulMusaddik: makeInternalContact(1095192, 'musaddik@innoscripta.com')
}
